import { Box, Button, Typography } from '@mui/material'
import Image from 'next/image'
import { useRouter } from 'next/router'
import Translations from 'src/@core/layouts/components/Translations'

const DashboardNoLand = () => {
  const router = useRouter()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        mt: 10
      }}
    >
      <Image src={'/No-land-image.png'} alt='Sin Campos' width={370} height={370} />
      <Typography sx={{ fontWeight: '700', fontSize: 'clamp(10px,30px,60px)', textAlign: 'center' }}>
        <Translations text={'Create your land!'} />
      </Typography>
      <Typography sx={{ fontWeight: '400', fontSize: 'clamp(10px,26px,60px)', mt: 4, textAlign: 'center' }}>
        <Translations text={'Create your land in Terratio to get its potential'} />
      </Typography>
      <Button
        onClick={() => router.push(`/operation-units`)}
        sx={{ bgcolor: '#213D36', color: 'white', height: 40, mt: 5, width: 300 }}
      >
        <Translations text={'BEGIN'} />
      </Button>
    </Box>
  )
}

export default DashboardNoLand
